import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  container: {
    '&:hover': {
      '& path': {
        fill: theme.palette.common.gray600,
        stroke: theme.palette.common.gray600,
      },
    },
    height: 16,

    width: 16,
  },
}));

export default useStyles;
